module.exports = ".chart-container {\n  width: 100%;\n  overflow-x: hidden;\n}\n.chart-container .chart {\n  margin-top: 0px;\n}\n.chart-container .loading {\n  background-color: rgba(255, 255, 255, 0.5);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.chart-container .loading img {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -20px;\n  margin-top: -20px;\n  width: 25px;\n  height: 25px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/chart-legend/chart-legend.component.less
// module id = ./src/app/projects/project/chart-legend/chart-legend.component.less
// module chunks = main